import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import { Link } from 'react-router-dom'
import ContextMenu from '../../ui/ContextMenu'
import Edit from '../../icons/ui/Edit'
import { IActiveTripResponseV2 } from '../../../types'
import { secondsToMinutes, convertCentsToDollars } from '../../../utils'
import UIMessages from '../../../utils/ui-messages'
import Taxi from '../../icons/trips/Taxi'
import Star from '../../icons/ui/Star'
import TripActivityLog from '../../../containers/trips/TripActivityLog'
import { ITripGroupRides } from 'src/types/trip-group-rides'
import TripPaymentDisplay from './TripRiderDetails'

export interface ITripRequestedProps {
  currentTrip: IActiveTripResponseV2
  getTripById: (tripId: string) => void
}

class TripRequested extends React.Component<ITripRequestedProps> {
  private tripTimerId: any

  public componentDidMount() {
    this.tripTimerId = setInterval(this.refreshTrip, 60000)
  }

  public componentWillUnmount() {
    clearInterval(this.tripTimerId)
  }
  public getEta(trip: IActiveTripResponseV2) {
    if (trip.estimatedPickup) {
      return secondsToMinutes(trip.estimatedPickup)
    } else if (trip.averageEta) {
      return secondsToMinutes(trip.averageEta)
    }
    return 'Unavailable'
  }
  public render() {
    const { currentTrip } = this.props
    const { allottedTimeAtPickup = 0, allottedTimeAtDropoff = 0 } = currentTrip.product || {}
    const eta = this.getEta(currentTrip)
    const price = currentTrip.estimatedPrice ? `$${convertCentsToDollars(currentTrip.estimatedPrice)}` : 'Unavailable'
    const fare = currentTrip.estimatedFare ? `$${convertCentsToDollars(currentTrip.estimatedFare)}` : 'Unavailable'

    const operatorName = currentTrip.operator
      ? `${currentTrip.operator.firstName} ${currentTrip.operator.lastName}`
      : 'No operator assigned'
    const operatorPhone = currentTrip.operator ? currentTrip.operator.phone : ''

    const paymentMode =
      currentTrip.tripsGroupRides[0] && currentTrip.tripsGroupRides[0].fareType
        ? currentTrip.tripsGroupRides[0].fareType
        : currentTrip.paymentMode || 'Cash'

    return (
      <React.Fragment>
        <div className={'pl2 pt1 flex flex-wrap items-start bwidth1 bt-light-grey'}>
          <div className='flex flex-wrap items-center col-12'>
            <Taxi className='icon' />
            <div className='flex col-11'>
              <span className='font-dark-grey h6 weight-500 ml1'>{currentTrip.product.name}</span>
              <Star className='ml1 icon--small' />
              <span className='font-dark-grey h6 weight-500 ml-auto mr2'>{eta}</span>
            </div>
            <div className='flex col-12 pt1 pb1 ml-auto right-align'>
              <span className='font-grey2 h6 weight-500 ml-auto'>price: {price}</span>
              <span className='font-grey2 h6 weight-500 ml2 mr2'>fare: {fare}</span>
            </div>
          </div>
        </div>

        {currentTrip.operator && (
          <div className='col-10 pl2'>
            <div className='flex'>
              <p className='m0 font-black'>{operatorName}</p>
            </div>
            <div className='h6 font-grey2'>
              {currentTrip.service.name} {currentTrip.product.name}
            </div>
          </div>
        )}

        <div className='h6 font-grey2 pl1 mt1'>
          <span className='h6 font-black mr1'>Notes:</span>
          {currentTrip.notes}
        </div>
        <div className='flex justify-center'>
          <div className='mt3 position-relative ml-auto'>
            <MoonLoader sizeUnit={'px'} size={54} color={'#37c47e'} loading={true} />
          </div>
          <div className='ml-auto'>
            <ContextMenu>
              <Link to={`/trips/${currentTrip.id}/assign-operator`}>
                <Edit className='icon--small svg-stroke-grey3 mr1' />
                <span className='font-dark-grey'>Assign</span>
              </Link>
            </ContextMenu>
          </div>
        </div>
        <div className='flex justify-center'>
          <div className='mt3'>
            <p className='center m0'>{UIMessages.trip.findingYouARide}</p>
            <p className='center m0 font-small font-grey2'>{UIMessages.trip.averageAcceptTime2Minutes}</p>
          </div>
        </div>
        <div className='flex col-12 column-gap-16 fs-14 py2'>
          <div className='col-6 text-center'>
            <div className='pb1'>{'Allotted Time at Pickup'}</div>
            <div>{`${allottedTimeAtPickup} ${Number(allottedTimeAtPickup) <= 1 ? 'minute' : 'minutes'}`}</div>
          </div>
          <div className='col-6 text-center'>
            <div className='pb1'>{'Allotted Time at Drop-off'}</div>
            <div>{`${allottedTimeAtDropoff} ${Number(allottedTimeAtDropoff) <= 1 ? 'minute' : 'minutes'}`}</div>
          </div>
        </div>
        <TripPaymentDisplay
          tripsGroupRides={currentTrip.tripsGroupRides}
          paymentMode={paymentMode}
          serviceId={currentTrip.service.serviceId}
          tripId={currentTrip.id}
          riderCount={currentTrip.riderCount}
        />
      </React.Fragment>
    )
  }

  private refreshTrip = () => {
    this.props.getTripById(this.props.currentTrip.id)
  }
}

export default TripRequested



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripRequested.tsx